import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { getAppConfig, getSiteConfig } from '../../../config/config';
import styles from './InfoBlock.module.scss';
import * as utils from '../../../utils/OrderUtils';
import { ReactComponent as ATLogo } from '../../../svgs/at.svg';

function InfoBlock() {
  const { t } = useTranslation('common');
  const config = getAppConfig();

  const [showPaymentInfo, setShowPaymentInfo] = useState(false);

  useEffect(() => {
    const lang = utils.getLang();
    const siteConfig = getSiteConfig();
    const langs = siteConfig.depositEnabledLangs;
    if (langs.includes(lang)) {
      setShowPaymentInfo(true);
    }
  }, []);

  return (
    utils.isATBrand() ? (
      <>
        <h2 className={styles.customerAccountsSubtitle}>
          {t('login.info_box.title')}
        </h2>
        <p className={styles.customerAccountsIntro}>
          {t('login.info_box.info_p')}
        </p>
        <ul className={styles.list}>
          {showPaymentInfo && <li>{t('login.info_box.info_list1')}</li>}
          <li>{t('login.info_box.info_list2')}</li>
          <li>{t('login.info_box.info_list3')}</li>
        </ul>
        <p className={styles.linkBtn}>
          <a href="/">{t('login.info_box.link_text')}</a>
        </p>
        <h2 className={styles.customerAccountsSubtitle}>
          {t('login.info_box.get_in_touch')}
        </h2>
        <p className={styles.customerAccountsIntro}>
          {t('login.info_box.contact_text')}
        </p>
        <p className={styles.telephone}>
          <a href={`tel:${config.phone_number}`}>{config.phone_number}</a>
        </p>
        <p className={styles.opening}>{t('login.info_box.opening_hours')}</p>
      </>
    ) : (
      <>
        <h2 className={styles.customerAccountsSubtitle}>
          Contact Us
        </h2>
        <p className={styles.customerAccountsIntro}>
          If you need help with your booking, please don&apos;t hesitate to contact us.
        </p>
        <br />
        <h2 className={styles.customerAccountsSubtitle}>
          Phone
        </h2>
        <p className={styles.customerAccountsIntro}>
          <b>0800 221 8546</b>
          {' '}
          (or 0044 203 1950 657 from overseas)
        </p>
        <br />
        <h2 className={styles.customerAccountsSubtitle}>
          Email
        </h2>
        <p className={styles.customerAccountsIntro}>
          <a href="mailto:customerservices@americanattractions.co.uk" target="_blank" rel="noreferrer">customerservices@americanattractions.co.uk</a>
        </p>
        <br />
        <p className={styles.bookingText}>
          To make a new booking, return to
          <a href="https://www.attractiontickets.com/en" className={styles.logoLink}>
            <ATLogo className={styles.logo} />
          </a>
        </p>
      </>
    )
  );
}

export default InfoBlock;
